import styled from 'styled-components'

const Row = styled.div.attrs({ className: 'row' })<{ special?: boolean }>`
  margin-top: 24px;
  margin-bottom: 40px;

  @media (min-width: 768px) {
    margin-top: 60px;
    margin-bottom: 60px;
  }

  @media (max-width: 767px) {
    ${({ special }) =>
      special &&
      `
        margin: 0 -50px;
    `}
  }

  ${({ special }) =>
    special &&
    `
      padding-top: 0;
  `}
`

export default Row
